import { render } from "./ViewTransits.vue?vue&type=template&id=78a8ce9d&scoped=true"
import script from "./ViewTransits.vue?vue&type=script&lang=js"
export * from "./ViewTransits.vue?vue&type=script&lang=js"

import "./ViewTransits.vue?vue&type=style&index=0&id=78a8ce9d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a8ce9d"]])

export default __exports__